import BaseModal from './BaseModal.jsx'
import { ModalContentWrapper } from './BaseModal.styles'
export default BaseModal
export { ModalContentWrapper }



// WEBPACK FOOTER //
// ./src/components/Modal/baseModal/index.js